<template>
  <v-container fluid pa-0 ma-0>
    <v-row justify="center" no-gutters>
      <v-col cols="12" lg="9">
        <div :id="mapid" style="height: calc(100vh - 64px); width: 100%;"></div>
      </v-col>

      <v-col cols="12" lg="3">
        <v-card class="fill-height" tile>
          <v-card-title>
            {{ title }}
          </v-card-title>

          <v-card-text>
            <v-form ref="form">
              <!--v-autocomplete label="Município"
                v-model="params.municipio"
                :items="municipios" item-text="nome" item-value="codibge"
                clearable dense multiple chips deletable-chips
              /-->
              <v-autocomplete label="Tipo de Equipamento"
                v-model="params.tipo_equipamento"
                :items="options.tipoEquipamento" item-text="descricao" item-value="codigo"
                @change="getRecurso(); getAtividade(); getEspecificacao(); getServico()"
                clearable dense multiple chips deletable-chips
              />
              <v-autocomplete label="Recurso"
                v-model="params.recurso"
                :items="options.recurso" item-text="descricao" item-value="codRecurso"
                :disabled="options.recurso.length === 0"
                clearable dense multiple chips deletable-chips
              />
              <v-text-field label="Quantidade Mínima de Recursos"
                :disabled="options.recurso.length === 0"
                v-model="params.qtde_recurso"
                clearable
              />
              <v-autocomplete label="Atividade"
                v-model="params.atividade"
                :items="options.atividade" item-text="descricao" item-value="codigo"
                :disabled="options.atividade.length === 0"
                clearable dense multiple chips deletable-chips
              />
              <v-autocomplete label="Especificação"
                v-model="params.especificacao"
                :items="options.especificacao" item-text="descricao" item-value="codigo"
                :disabled="options.especificacao.length === 0"
                clearable dense multiple chips deletable-chips
              />
              <v-autocomplete label="Serviço"
                v-model="params.servico"
                :items="options.servico" item-text="descricao" item-value="codigo"
                :disabled="options.servico.length === 0"
                clearable dense multiple chips deletable-chips
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn @click="reset()">Limpar</v-btn>
            <v-btn @click="addLayer()" color="#244EA2" dark>
              Pesquisar
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-bottom-sheet v-model="dialog">
          <v-card>
            <v-card-title>
              {{ title }}
              <v-spacer />
              {{ name }}
              <v-btn icon @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :page.sync="page"
            >
              <template v-slot:item.dataCriacao="{ item }">
                {{ formatDate(item.dataCriacao) }}
              </template>

              <template v-slot:item.qtdeAtividades="{ item }">
                <div v-if="item.qtdeAtividades !== 0">
                  {{ item.qtdeAtividades }}
                  <v-btn
                    @click="name2 = item.descricao; getAtividades(item.codigo); dialog2 = true"
                    icon color="indigo darken-3"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:item.qtdeEspecificacoes="{ item }">
                <div v-if="item.qtdeEspecificacoes !== 0">
                  {{ item.qtdeEspecificacoes }}
                  <v-btn
                    @click="name3 = item.descricao; getEspecificacoes(item.codigo); dialog3 = true"
                    color="indigo darken-3" icon
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:item.qtdeRecursos="{ item }">
                <div v-if="item.qtdeRecursos !== 0">
                  {{ item.qtdeRecursos }}
                  <v-btn
                    @click="name4 = item.descricao; getRecursos(item.codigo); dialog4 = true"
                    color="indigo darken-3" icon
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:item.qtdeServicos="{ item }">
                <div v-if="item.qtdeServicos !== 0">
                  {{ item.qtdeServicos }}
                  <v-btn
                    @click="name5 = item.descricao; getServicos(item.codigo); dialog5 = true"
                    color="indigo darken-3" icon
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet v-model="dialog2" inset>
          <v-card>
            <v-card-title>
              Atividades
              <v-spacer />
              {{ name2 }}
              <v-btn icon @click="dialog2 = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-data-table :headers="headers2" :items="items2" />
          </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet v-model="dialog3" inset>
          <v-card>
            <v-card-title>
              Especificações
              <v-spacer />
              {{ name3 }}
              <v-btn icon @click="dialog3 = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-data-table :headers="headers3" :items="items3" />
          </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet v-model="dialog4" inset>
          <v-card>
            <v-card-title>
              Recursos
              <v-spacer />
              {{ name4 }}
              <v-btn icon @click="dialog4 = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-data-table :headers="headers4" :items="items4" />
          </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet v-model="dialog5" inset>
          <v-card>
            <v-card-title>
              Serviços
              <v-spacer />
              {{ name5 }}
              <v-btn icon @click="dialog5 = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-data-table :headers="headers5" :items="items5" />
          </v-card>
        </v-bottom-sheet>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import { defaults, isEmpty, uniqueId } from 'lodash'
import moment from 'moment'

import api from '@/api/vue-exemplo'
import { equipamento } from '@/api/vue-exemplo'

import { getBounds, toViewParams } from '@/domain/library'

export default {
  name: 'Equipamento',
  data: () => ({
    mapid: null,

    title: 'Equipamentos Culturais',

    info: null,
    legend: null,

    options: {
      tipoEquipamento: [],
      recurso: [],
      atividade: [],
      especificacao: [],
      servico: []
    },
    params: {
      tipo_equipamento: null,
      recurso: null,
      qtde_recurso: null,
      atividade: null,
      especificacao: null,
      servico: null,
      //municipio: null
    },

    dialog: false,
    loading: false,
    name: null,
    items: [],
    page: 1,
    headers: [
      { text: 'Equipamento', value: 'descricaoTipoEquipamento' },
      { text: 'Descrição', value: 'descricao' },
      // { text: 'Município', value: 'nomeMunicipio' },
      { text: 'Endereço', value: 'endereco' },
      { text: 'Número', value: 'numero' },
      { text: 'Data Criação', value: 'dataCriacao' },
      { text: 'Atividades', value: 'qtdeAtividades' },
      { text: 'Especificações', value: 'qtdeEspecificacoes' },
      { text: 'Recursos', value: 'qtdeRecursos' },
      { text: 'Serviços', value: 'qtdeServicos' }
    ],

    dialog2: false,
    name2: null,
    items2: [],
    headers2: [
      { text: 'Descrição', value: 'tipoAtividade.descricao' }
    ],

    dialog3: false,
    name3: null,
    items3: [],
    headers3: [
      { text: 'Especificação', value: 'tipoEspecificacao.descricao', width: '50%' },
      { text: 'Descrição da Especificação', value: 'descricao', width: '50%' }
    ],

    dialog4: false,
    name4: null,
    items4: [],
    headers4: [
      { text: 'Descrição', value: 'tipoRecurso.descricao' },
      { text: 'Quantidade', value: 'quantidade' }
    ],

    dialog5: false,
    name5: null,
    items5: [],
    headers5: [
      { text: 'Descrição', value: 'tipoServico.descricao' }
    ]
  }),
  computed: {
    /*municipios () {
      return this.$store.getters.municipios
    }*/
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onResize()
    })
  },
  mounted () {
    this.mapid = uniqueId()
    this.$nextTick(() => {
      this.map = L.map(this.mapid)
      this.map.fitBounds(getBounds())
      esri.basemapLayer('Topographic').addTo(this.map)

      L.Control.geocoder({
        position: "topleft",
        placeholder: "Pesquisar..."
      }).addTo(this.map)

      L.control.defaultExtent({
        title: 'Visão Inicial'
      }).addTo(this.map)

      this.addLayer()
    })

    this.$store.dispatch('getMunicipios')

    api.getTipoEquipamento()
      .then(response => {
        this.options.tipoEquipamento = response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    reset () {
      this.$refs.form.reset()
      this.options.recurso = []
      this.options.atividade = []
      this.options.especificacao = []
      this.options.servico = []
      this.removeLayer()
    },
    getColor (quantity) {
      return quantity > 50 ? '#006837' :
        quantity > 20 ? '#31a354' :
        quantity > 5 ? '#78c679' :
        '#c2e699'
    },
    /*
    getColor (quantity) {
      return quantity > 50 ? '#238443' :
        quantity > 20 ? '#78c679' :
        quantity > 5 ? '#c2e699' :
        '#ffffcc'
    },
    */
    addLayer () {
      this.removeLayer()

      // Custom Info Control

      this.info = L.control()

      this.info.onAdd = function () { /* map */
        this._div = L.DomUtil.create('div', 'leaflet-info')
        this.update()
        return this._div
      }

      this.info.update = function (props) {
        this._div.innerHTML = '<h4>Equipamentos Culturais</h4>' + (props
          ? '<b>' + props.nome + '</b><br />' + props.qtde
          : 'Passe o mouse sobre um município'
        )
      }

      this.info.addTo(this.map)

      var style = (feature) => {
        return {
          fillColor: this.getColor(feature.properties.qtde),
          weight: 2,
          opacity: 1,
          color: 'white',
          dashArray: '3',
          fillOpacity: 0.7
        }
      }

      var highlightFeature = (e) => {
        var layer = e.target
        layer.setStyle({
          weight: 5,
          color: '#666',
          dashArray: '',
          fillOpacity: 0.7
        })
        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront()
        }
        this.info.update(layer.feature.properties)
      }

      var resetHighlight = (e) => {
        this.geojson.resetStyle(e.target)
        this.info.update()
      }

      var onEachFeature = (feature, layer) => {
        layer.on({
          mouseover: highlightFeature,
          mouseout: resetHighlight,
          click: (e) => {
            resetHighlight(e)
            this.dialog = true
            this.name = feature.properties.nome
            var codibge = feature.properties.codibge
            this.items = []
            this.loading = true
            this.page = 1

            api.getEquipamento(defaults({ codibge: codibge }, this.params))
              .then(response => {
                this.items = response.data
              })
              .catch(error => {
                console.log(error)
              })
              .finally(() => {
                this.loading = false
              })
          }
        })
      }

      this.$store.commit('setLoading', true)

      axios.get(process.env.VUE_APP_GEOSERVER, {
        params: {
          service: 'wfs',
          version: '2.0.0',
          outputFormat: 'application/json',
          exceptions: 'application/json',
          request: 'GetFeature',
          typeNames: 'seec:sqlvw_equipamento_cultural_pol_p29192',
          srsName: 'EPSG:4674',
          viewParams: toViewParams({
            pEquipamentoCulturalCodigo: this.params.tipo_equipamento,
            pEquipamentoCulturalRecurso: this.params.recurso,
            pQuantidadeRecurso: this.params.qtde_recurso,
            pEquipamentoAtividade: this.params.atividade,
            pEquipamentoEspecificacao: this.params.especificacao,
            pEquipamentoServico: this.params.servico
            //pEquipamentoMunicipio: this.params.municipio
          })
        }
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            style: style,
            onEachFeature: onEachFeature
          }).addTo(this.map)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.$store.commit('setLoading', false)
        })

      this.createLegend()
    },
    removeLayer () {
      if (this.geojson) {
        this.map.removeLayer(this.geojson)
        this.geojson = null
      }

      if (this.info) {
        this.map.removeControl(this.info)
        this.info = null
      }

      this.removeLegend()
    },
    createLegend () {
      this.legend = L.control({
        position: 'bottomright'
      })

      this.legend.onAdd = () => {
        var div = L.DomUtil.create('div', 'leaflet-info leaflet-legend'),
          grades = [0, 5, 20, 50]

        for (var i = 0; i < grades.length; i++) {
          div.innerHTML += '<i style="background: ' + this.getColor(grades[i] + 1) +'"></i>'
          div.innerHTML += grades[i] + (grades[i + 1] ? ' &ndash; ' + grades[i + 1] + '<br>' : '+')
        }
        return div
      }

      this.legend.addTo(this.map)
    },
    removeLegend () {
      if (this.legend) {
        this.map.removeControl(this.legend)
        this.legend = null
      }
    },
    getRecurso () {
      if (isEmpty(this.params.tipo_equipamento)) {
        this.options.recurso = []
      } else {
        api.getRecurso(this.params.tipo_equipamento)
          .then(response => {
            this.options.recurso = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getAtividade () {
      if (isEmpty(this.params.tipo_equipamento)) {
        this.options.atividade = []
      } else {
        api.getTiposAtividade(this.params.tipo_equipamento)
          .then(response => {
            this.options.atividade = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getEspecificacao () {
      if (isEmpty(this.params.tipo_equipamento)) {
        this.options.especificacao = []
      } else {
        api.getEspecificacao(this.params.tipo_equipamento)
          .then(response => {
            this.options.especificacao = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getServico () {
      if (isEmpty(this.params.tipo_equipamento)) {
        this.options.servico = []
      } else {
        api.getServico(this.params.tipo_equipamento)
          .then(response => {
            this.options.servico = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    getAtividades (codigo) {
      equipamento.getAtividades({
        codigo: codigo
      })
        .then(response => {
          this.items2 = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getEspecificacoes (codigo) {
      equipamento.getEspecificacoes(codigo)
        .then(response => {
          this.items3 = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getRecursos (codigo) {
      equipamento.getRecursos(codigo)
        .then(response => {
          this.items4 = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getServicos (codigo) {
      equipamento.getServicos(codigo)
        .then(response => {
          this.items5 = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    formatDate (date) {
      return date ? moment(date).format('DD/MM/YYYY') : null
    },
    onResize () {
      if (this.map) {
        this.map.invalidateSize()
      }
    }
  }
}
</script>
